import { GameManager } from "../Managers/GameManager";

export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    //indicates respin scene until first spin
    public static InRespin: boolean = false;

    public static readonly SymbolTen: number = 1;
    public static readonly SymbolJack: number = 2;
    public static readonly SymbolQueen: number = 3;
    public static readonly SymbolKing: number = 4;
    public static readonly SymbolAce: number = 5;
    public static readonly SymbolSkull: number = 6;
    public static readonly SymbolShoe: number = 7;
    public static readonly SymbolGun: number = 8;
    public static readonly SymbolMoney: number = 9;
    public static readonly SymbolStar: number = 10;
    public static readonly SymbolSheriff: number = 11;
    public static readonly SymbolBandit: number = 12;
    public static readonly SymbolMystery: number = 13;

    //inidicates respin scene until in response
    public static isRespin(): boolean {
        if (GameManager.baseResponse) {
            return GameManager.baseResponse.respin != null && GameManager.baseResponse.respin !== 0;
        }

        return false;
    }

    public static isWild(id: number): boolean {
        return id == Settings.SymbolSheriff || id == Settings.SymbolBandit;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/